import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'quantity-input',
  templateUrl: './quantity-input.component.html',
  styleUrls: ['./quantity-input.component.less']
})
export class QuantityInputComponent implements OnInit {


  @Input() mode: string = 'table';
  @Input() quantity: number = 0;
  tempQuantity: number | undefined;
  @Input() inputQuantity?: string = '0';
  @Input() moq: number = 1; // Minimum Order Quantity
  @Input() errorTypes: string[] = [];
  @Output() quantityChange = new EventEmitter<number>();
  @Output() quantityBlur = new EventEmitter<number>();

  ngOnInit() {
    //this.adjustQuantityToMoq();
  }

  adjustQuantityToMoq() {
    const moq = this.moq===0?1:this.moq;
    if (this.quantity ===0 || this.quantity < moq) {
      this.quantity = moq;
    } else if (this.quantity % moq !== 0) {
      this.quantity = Math.ceil(this.quantity / moq) * moq;
    }
    this.quantityChange.emit(this.quantity);
  }

  decrease() {
    const moq = this.moq===0?1:this.moq;
    const newQuantity = this.quantity - moq;
    if (newQuantity >= moq) {
      this.quantity = newQuantity;
      this.quantityChange.emit(this.quantity);
    }
  }

  increase() {
    const moq = this.moq===0?1:this.moq;
    this.quantity += moq;
    this.quantityChange.emit(this.quantity);
  }

  onBlur() {
    if (this.tempQuantity === null || this.tempQuantity === undefined) {
      return;
    }
    this.quantity = this.tempQuantity;
    this.adjustQuantityToMoq();
    this.quantityBlur.emit(this.quantity);
  }

  onInputChange(value: number) {
    this.tempQuantity = value;
  }

}
